module.exports = __webpack_public_path__ + "officialStatic/img/parentA.a18eff0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/smartCampus/role/parentA.png
// module id = 2QjB
// module chunks = 0